
import Component from "vue-class-component"
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import Axios from "axios"

@Component
export default class ApiHtmlTable extends Vue {
  @Prop({required: true})
  chartId: string

  @Prop({default: null})
  title: string

  tableHtml: string | null = null

  async created() {
    Axios.get(`/api/charts/${this.chartId}`)
      .then(response => {
        this.tableHtml = response.data
      })
      .catch(reason => {
        console.error(`Failed loading chart: ${String(reason)}`)
        this.tableHtml = null
      })
  }
}
